import { action } from 'mobx';
import * as React from 'react';
import { PageComponent } from '../../../../utils';
import {
  PageProps,
  PageToolEvents,
} from '../../../../constants';
import { InfinityRetrieve } from '../../../../models';
import { ExcelHistoryTemplate } from './ExcelHistory.template';
import { Date8 } from '../../../../utils/time';
import { ExcelHistoryModel } from './ExcelHistory.model';
import { GridLayout } from '../../../../components';
import { ConfirmWarning } from '../../../../utils/confirm';

interface ExcelHistoryState {
  // 조회
  stdate: string;
  enddate: string;
  searchQuery: string;
  perid: string;
  pernm: string;

  // 리스트
  excelHistoryList: Array<ExcelHistoryModel>;
}

/**
 * 컨트롤러
 * @window w_tb_excel_history
 * @category 엑셀출력기록
 */
export class ExcelHistory extends PageComponent<PageProps, ExcelHistoryState> implements PageToolEvents {
  infinity?: InfinityRetrieve;

  grid: React.RefObject<GridLayout> = React.createRef();

  constructor(props: PageProps, context: any) {
    super(props, context);
    this.props.onMount && this.props.onMount(this);

    this.state = {
      // 조회
      stdate: `${Date8.make().substr(0, 6)}01`,
      enddate: Date8.make(),
      searchQuery: '',
      perid: '',
      pernm: '',

      // 리스트
      excelHistoryList: [],
    };
  }

  @action
  onFirstOpenEvent() {
    this.onRetrieveEvent();
  }

  @action
  async onRetrieveEvent() {
    const { actionStore: api } = this.props;

    this.infinity = new InfinityRetrieve(
      {
        stdate: this.state.stdate,
        enddate: this.state.enddate,
        as_nm: this.state.searchQuery,
        perid: this.state.perid,
      },
      (params) => api.retrieve(params),
      (items, next) => {
        this.setState({
          excelHistoryList: [...this.state.excelHistoryList, ...items.map((item) => new ExcelHistoryModel(item))],
        }, next);
      },
      async () => {
        await this.SS({
          excelHistoryList: [],
        });
        await this.infinity?.retrieve();
        this.grid.current?.setFocus(0);
      },
    );

    // 초기화
    await this.SS({
      excelHistoryList: [],
    });

    // 조회
    await this.infinity?.retrieve();
    this.grid.current?.setFocus(0);
  }

  @action
  async onPrintEvent() {
    const { actionStore: api } = this.props;
    if (!ConfirmWarning.assert(this.state.excelHistoryList.length, '오류', '출력할 내역이 없습니다.')) {
      return;
    }
    await api.printWithElmanManager({
      stdate: this.state.stdate,
      enddate: this.state.enddate,
      as_nm: this.state.searchQuery,
      perid: this.state.perid,
    });
  }

  @action
  async onExcelEvent() {
    const { actionStore: api } = this.props;
    if (this.state.excelHistoryList.length < 1) {
      ConfirmWarning.show('오류', '엑셀전환할 내역이 없습니다.');
      return;
    }

    await api.excel({
      stdate: this.state.stdate,
      enddate: this.state.enddate,
      as_nm: this.state.searchQuery,
      perid: this.state.perid,
    });
  }

  render() {
    return (
      <ExcelHistoryTemplate scope={this} />
    );
  }
}
